export const instructorMenuItems = [
	{
		title: 'Class List',
		path: '/instructor/class-management',
		icon: 'users'
	},
	{
		title: 'Schedule',
		path: '/instructor/schedules',
		icon: 'calendar'
	},
	{
		title: 'College List',
		path: '/instructor/colleges',
		icon: 'graduation'
	},
	{
		title: 'Resource Center',
		path: '/instructor/resources',
		icon: 'folder'
	},
	{
		title: 'Class Task',
		path: '/instructor/tasks',
		icon: 'check-square'
	},
	{
		title: 'Private Notes',
		path: '/instructor/private-notes',
		icon: 'file-text'
	}
]
